<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Empresariales</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro de Infidelidad y Riesgos Financieros</h1>
                <p>En promedio, 8 de cada 10 empresas se ven afectadas por acciones fraudulentas o corruptas. Respalde su
                compañía frente a los riesgos a los que se expone por acciones malintencionadas de empleados y terceros.
                </p>
        </div>
        <div class="especialidades-slide">
            <center><h1>Con el Seguro de Infidelidad y Riesgos Financieros su empresa podrá:</h1>
            <VueSlickCarousel
                class="slider2"
                ref="slick"
                v-bind="slickOptionsExperiencies"
                :arrows="false">
                <div v-for="(slide, i) in especialidades" :key="i" class="especial">
                    <img :src="slide.image" alt="">
                    <p>{{slide.texto}}</p>
                </div>
            </VueSlickCarousel>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Actuar con responsabilidad es una de las características más importantes de los buenos empresarios. Cuando el panorama en el que se
                desenvuelven las organizaciones se torna cada vez más complejo por los numerosos riesgos a los que se exponen, tomar decisiones
                pensando en el futuro es esencial.
                <br>
                <br>
                Para que las empresas protejan su patrimonio frente a las pérdidas que se generen por actos deshonestos de sus empleados o de
                terceros, se ofrece el Seguro de Infidelidad y Riesgos Financieros, que se convertirá en una parte fundamental del engranaje de su gestión
                empresarial de cara al sostenimiento.
                <br>
                <br>
                <span>Permítanos asesorarlo y que gestionemos sus riesgos.</span>
                </p>
            </center>
        </div>
        <div class="slide-cobertura-opcional">
            <center><h1>¿Qué se cubre?</h1></center>
            <VueSlickCarousel
            class="slider"
            ref="slick"
            :autoplay="true"
            :dots="true"
            :arrows="false">
                <div v-for="(slide, i) in coberturaPrincipal" :key="i">
                    <div class="cobertura-principal-slide">
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">{{slide.label}}</label>
                        </div>
                       <p v-html="slide.p"></p>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div class="cubrimos">
            <div class="service" v-for="(service, i) in services" :key="i">
                <div v-if="service.type">
                    <div class="imgbox">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box">
                        <h1>{{service.label}}</h1>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Cuál es el valor asegurado?</h1>
            <p>El límite máximo para asegurar es $5 000 000 000 (cinco mil millones de pesos). Si el valor es mayor, debe presentar su caso a la aseguradora.
            El valor asegurado nunca podrá ser superior al total de los activos de su compañía.</p>
        </div>
        <div class="texto">
            <center><h1>Requisitos para acceder al seguro</h1></center>
            <center class="box">
                <p><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>No se aseguran compañías con menos de tres años de operación. Tampoco las empresas que desarrollen actividades como
                minería, droguerías y laboratorios, transportadoras de valores, joyerías, empresas de seguridad, entidades prestadoras de salud
                (EPS), entre otras.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Presentar los formularios debidamente diligenciados, fechados y suscritos por el representante legal, los estados financieros del
                último año y el informe del revisor fiscal.
                </p>
            </center>
        </div>
        <div class="texto">
            <center><h1>¿Cuál es la diferencia entre el Seguro de Infidelidad y Riesgos Financieros y el de Fraude de Empleados?</h1></center>
            <center class="box">
                <p><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>El Seguro de Fraude de Empleados cubre pérdidas de dinero u otros bienes que, si bien pueden ser más frecuentes, no son
                representativas. El de Infidelidad y Riesgos Financieros cubre a su empresa frente a eventos graves que pueden poner en riesgo
                su patrimonio.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>¿Busca proteger su empresa de acciones deshonestas tanto de sus empleados como de terceros? Entonces el Seguro de Infidelidad
                y Riesgos Financieros es su mejor alternativa. El de Fraude de Empleados solo lo apoya si los responsables de las afectaciones
                tienen un vínculo contractual con su organización.
                </p>
            </center>
        </div>
        <div class="move"><center><img src="@/assets/Todo-riesgo-empresarial/4.png" alt=""></center></div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Infidelidad-riesgos-financieros',
    metaInfo() {
        return {
            title: 'Seguro de Infidelidad y Riesgos Financieros',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'En promedio, 8 de cada 10 empresas se ven afectadas por acciones fraudulentas o corruptas. Respalde su compañía frente a los riesgos a los que se expone por acciones malintencionadas de empleados y terceros.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            services: [
                {
                    type: true,
                    img: require('@/assets/Infidelidad-Riesgos-Financieros/4.png'),
                    label: '¿Qué no se cubre?',
                    p: [
                        'Las pérdidas causadas por la infidelidad o falsificación a manos de o con la contribución de un socio de su empresa, excepto si está involucrado uno de sus empleados (lo respaldaría la cobertura de infidelidad de empleados).',
                        'Las afectaciones producidas por guerra (declarada o no), insurrección, rebelión o revolución, intervención gubernamental, expropiación, nacionalización u otros hechos similares a los mencionados.',
                        'Lucro cesante.',
                        'Pérdida de información.',
                        'No amparamos las pérdidas que no hayan sido descubiertas antes de la terminación de la vigencia del seguro o cualquiera de sus coberturas.'
                    ]
                }
            ],
            coberturaPrincipal: [
                {
                    label: 'Infidelidad de empleados',
                    p: 'Se pagara a su empresa cuando sufra pérdidas de dinero, títulos valores u otras propiedades por un acto de infidelidad o falsificación cometido por uno de sus empleados, sea que haya actuado solo o con otras personas.'
                },
                {
                    label: 'Predios',
                    p: 'Se asumen las pérdidas económicas causadas por la destrucción, la desaparición y el hurto de dinero, títulos valores u otras propiedades a manos de terceros en las instalaciones de la empresa.'
                },
                {
                    label: 'Tránsito',
                    p: 'Se reapandara cuando dinero o títulos valores de su empresa sean destruidos o hurtados por un tercero mientras estos estaban siendo movilizados por una persona autorizada por su empresa'
                },
                {
                    label: 'Falsificación de cheques y otros documentos',
                    p: 'Lo indemnizaremos si su empresa sufre pérdidas económicas por los actos de un tercero que falsifica o altera un instrumento financiero.'
                },
                {
                    label: 'Hurto por computador',
                    p: 'Lo acompañaremos en el evento que un tercero ingrese a su sistema de información y modifique, elimine o robe algún dato, y ello le genere pérdidas o afectaciones económicas a su empresa'
                }
            ],
            coberturaOpcional: [
                {
                    label: 'Para daños materiales',
                    p: '• Terremoto, temblor de tierra, erupción volcánica, maremoto y tsunami. <br><br> • Suelos y terrenos. <br><br> • Actos malintencionados de terceros, huelga, motín, asonada, conmoción civil o popular y terrorismo. <br><br> • Gastos adicionales: si su empresa debe incurrir en diferentes gastos por la ocurrencia de un siniestro amparado por este seguro, recibirá la indemnización hasta el valor asegurado. Por ejemplo: si debe remover escombros, reponer documentos o bienes pertenecientes a directivos y empleados, entre otras situaciones. <br><br> • Renta y pérdida de ingreso por arrendamiento: si su empresa debe incurrir en gastos de arrendamiento o se disminuyen sus ingresos por este concepto a consecuencia de un siniestro amparado por Plan Empresa, recibirá la indemnización hasta el valor asegurado.'
                },
                {
                    label: 'Sustracción',
                    p: 'Pagamos los daños o las pérdidas de bienes materiales que su empresa haya sufrido por robo en las sedes aseguradas, haya sido con o sin violencia. La indemnización será hasta el valor asegurado. Se excluyen los daños o pérdidas de bienes en lugares exteriores, el lucro cesante y los robos producidos a causa de guerra, incendio, explosión u otros eventos naturales.'
                },
                {
                    label: 'Daño interno',
                    p: 'Asumimos los daños internos súbitos, imprevistos y accidentales que sufran máquinas y equipos, equipos de cómputo o procesamiento de datos, y bienes refrigerados de su empresa si están en las sedes aseguradas. No importa si estos se usan o se están desmontando para revisión, limpieza, mantenimiento, renovación o fines similares.'
                },
                {
                    label: 'Lucro cesante',
                    p: 'Si su empresa debe detener sus actividades por daños o pérdidas materiales de bienes asegurados, lo apoyamos económicamente por los perjuicios que esto le genere. Los daños o las pérdidas mencionadas deben ser causadas por eventos no excluidos en la cobertura de daños materiales.'
                },
                {
                    label: 'Cobertura por fuera de sedes',
                    p: 'Si su empresa tiene contenidos, máquinas y equipos, equipos de cómputo o procesamiento de datos por fuera de su sede, estos requieren protección en caso de daños o pérdidas. SURA asume el costo de las afectaciones siempre y cuando sean consecuencia de hechos no excluidos en la cobertura de daños materiales.'
                },
                {
                    label: 'Asistencia empresarial',
                    p: 'Le brindamos apoyo especializado ante los daños que pueden afectar el funcionamiento de su empresa o el normal desarrollo de sus actividades. Ofrecemos servicio de plomería, electricidad, cerrajería, reemplazo de vidrios, seguridad, asistencia jurídica telefónica y traslado por urgencia.'
                },
                {
                    label: 'Responsabilidad civil por daños a terceros',
                    p: 'Lo protegemos por daños materiales, lesiones personales o muerte que se les ocasionen a terceros en las sedes aseguradas de su empresa o durante el desarrollo de sus actividades productivas.'
                },
                {
                    label: 'Fraude de empleados',
                    p: 'Asumimos los riesgos relacionados con sus empleados cuando actúen de manera deshonesta y, con ello, su empresa sufra pérdidas u otros perjuicios. Cubrimos hurto, hurto calificado, abuso de confianza, falsedad o estafa, por parte de sus empleados.'
                },
                {
                    label: 'Protección legal',
                    p: 'Cuente con el apoyo de un abogado que defienda su empresa frente a procesos administrativos y con la asistencia jurídica telefónica para que lo oriente ante un proceso judicial.'
                },
                {
                    label: 'Protección digital',
                    p: 'Lo acompañamos económicamente si su empresa sufre ataques informáticos en sus sistemas y por ello pierde o se roban información, si se instalan virus o softwares infecciosos que afectan sus datos, si debe efectuar gastos de emergencia para evitar la propagación de las afectaciones y mucho más'
                },
                {
                    label: 'Transporte de valores',
                    p: 'Proteja el dinero en efectivo y los títulos valores de su empresa frente a los riesgos de daño o pérdida a los que se ven expuestos durante su movilización, se incluye el transporte marítimo y fluvial y se respalda el hurto calificado, es decir con uso de violencia y fuerza'
                },
                {
                    label: 'Transporte de mercancías automático',
                    p: 'Respalde las mercancías que su empresa moviliza de manera frecuente ante hechos como hurto, extravío, pérdida y daño.'
                },
                {
                    label: 'Transporte de mercancías específico',
                    p: 'Si su empresa debe hacer solo un envío de mercancía y necesita protegerlo frente a daños o pérdidas durante su movilización, esta solución es la indicada.'
                }
            ],
            slickOptionsExperiencies: {
                'dots': false,
                'arrows': true,
                'focusOnSelect': true,
                'infinite': true,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 3,
                'touchThreshold': 5,
                'responsive': [
                    {
                        'breakpoint': 1140,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true
                        }
                    },
                    {
                        'breakpoint': 680,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'infinite': true
                        }
                    }
                ]
            },
            especialidades: [
                {
                    image: require('@/assets/Infidelidad-Riesgos-Financieros/1.png'),
                    texto: 'Proteger su patrimonio ante actos de infidelidad cometidos por empleados y terceros.'
                },
                {
                    image: require('@/assets/Infidelidad-Riesgos-Financieros/2.png'),
                    texto: 'Respaldar dinero, bienes o títulos valores destruidos o hurtados durante su transporte.'
                },
                {
                    image: require('@/assets/Infidelidad-Riesgos-Financieros/3.png'),
                    texto: 'Ser indemnizada por pérdidas económicas causadas por falsificación o alteración de instrumentos financieros.'
                },
                {
                    image: require('@/assets/Infidelidad-Riesgos-Financieros/5.png'),
                    texto: 'Contar con el acompañamiento de Seguros SURA para su gestión segura y responsable.'
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>
<style>
    .cobertura-principal-slide > p > span {
        font-weight: bold;
        margin-left: 5em;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 25px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 5px;
        margin-bottom: 15px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
</style>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
        width: 60%;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .slider2 {
        width: 70%;
    }
    .especialidades-slide{
        padding-top: 40px;
    }
    .especialidades-slide > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        font-size: 30px;
    }
    .especialidades > div {
        height: 500px;
    }
    .especial img {
        width: 100%;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    .especial > p {
        font-family: 'JR';
        padding: 10px;
        text-align: left;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .cobertura-principal {
        width: 100%;
        padding: 0px 300px;
    }
    .cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
    }
    .cobertura-principal > div {
        display: flex;
        margin-bottom: 50px;
    }
    .cobertura-principal > div > center > img {
        width: 200px;
        height: auto;
    }
    .cobertura-principal > div > div {
        padding: 20px;
    }
    .cobertura-principal > div > div > div > img{
        width: 50px;
        margin-right: 20px;
    }
    .cobertura-principal > div > div > div > label{
        font-family: 'JBD';
        color: #65b24a;
        font-size: 20px;
    }
    .cobertura-principal > div > div {
        padding: 25px;
        margin-top: 20px;
        font-family: 'JR';
        -webkit-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        -moz-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
    }
    .cobertura-principal-slide{
        padding: 0px 300px;
    }
    .cobertura-principal-slide > div {
        display: flex;
    }
    .cobertura-principal-slide > div > label {
        color: #65b24a;
        font-family: 'JBD';
        font-size: 20px;
    }
    .cobertura-principal-slide > div > img {
        width: 50px;
    }
    .cobertura-principal-slide > p {
        font-family: 'JR';
        margin-top: 10px;
        margin-bottom: 60px;
    }
    .slide-cobertura-opcional > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .opcionales {
        padding: 50px 300px;
        font-family: 'JR';
    }
    .opcionales > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-bottom: 20px;
    }
    .opcionales > .opcional > .subopcional {
        padding-left: 50px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    .move > center > img {
        margin-top: 30px;
        width: 800px;
    }
    @media (max-width: 1600px) {
        .slider2 {
            width: 60%;
        }
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .slider2 {
            width: 65%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
        .slider2 {
            width: 70%;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal-slide{
            padding: 0px 200px;
        }
        .opcionales {
            padding: 50px 200px;
        }
        .slider2 {
            width: 75%;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
        .slider2 {
            width: 80%;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            width: 100%;
            padding: 10px;
            text-align: center;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 100px;
        }
        .cobertura-principal-slide{
            padding: 0px 100px;
        }
        .opcionales {
            padding: 50px 100px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .cobertura-principal > div {
            display: block;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
        .cobertura-principal {
            padding: 10px 50px;
        }
        .cobertura-principal-slide {
            padding: 0px 50px;
        }
        .opcionales {
            padding: 50px 50px;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .slide-cobertura-opcional > center > h1 {
            font-size: 30px;
        }
        .cobertura-principal > center > h1{
            font-size: 30px;
        }
        .opcionales > center > h1 {
            font-size: 30px;
        }
        .move > center > img {
            width: 300px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .move > center > img {
            width: 250px;
        }
        .especial img {
            width: 240px;
        }
        .cobertura-principal > div > div {
            padding: 20px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/InfidelidadRiesgosFinancieros.vue